export default __webpack_public_path__ + "static/media/secret.8e9b2e16.png";